import * as React from 'react';
import { Loader, useNotify } from 'ebs-design';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { ConfirmModal } from 'components/molecules';
import { ActionCard } from 'features/leads/ActionCard';
import { ContractForm } from './ContractForm';
import { ContractItem } from './ContractItem';
import { useContractAPI } from 'api';
import { Contract, Lead } from 'types';

const formId = 'add-contract';

interface ContractCardProps {
  lead: Lead;
}

export const ContractCard: React.FC<ContractCardProps> = ({ lead }) => {
  const { t } = useTranslation();
  const { id } = useParams();
  const notify = useNotify();
  const queryClient = useQueryClient();
  const { getLeadContracts, deleteContract } = useContractAPI();
  const [editId, setEditId] = React.useState();
  const [deleteId, setDeleteId] = React.useState();

  const { data, isLoading } = useQuery<Contract[]>(['contracts', { id }], getLeadContracts, {
    onError: () => {
      notify.error({ title: t('error.someThingIsWrong') });
    },
  });
  const mutation = useMutation(deleteContract, {
    onError: () =>
      notify.error({
        title: t('error.someThingIsWrong'),
      }),
    onSuccess: () => {
      queryClient.invalidateQueries(['contracts']);
      setDeleteId(undefined);
      notify.success({ title: t('success.successDataDelete') });
    },
  });

  const onEdit = (id): void => {
    setEditId(id);
  };
  const onDelete = (id): void => {
    setDeleteId(id);
  };

  const handleDelete = (): void => {
    if (deleteId) {
      mutation.mutate(deleteId);
    }
  };

  return (
    <>
      <ActionCard
        header={t('lead.contracts')}
        className="mt-20"
        type="contracts"
        backgroundColor="#43B9C5"
        formId={formId}
        count={data?.length}
        editId={editId}
        unsetEdit={() => setEditId(undefined)}
        FormComponent={ContractForm}
      >
        <Loader loading={isLoading}>
          {data?.length
            ? data.map((contract, key) => (
                <ContractItem
                  key={key}
                  contract={contract}
                  lead={lead}
                  onEdit={onEdit}
                  onDelete={onDelete}
                />
              ))
            : t('main.noData')}
        </Loader>
      </ActionCard>
      {deleteId && (
        <ConfirmModal onSuccess={handleDelete} onCancel={() => setDeleteId(undefined)} />
      )}
    </>
  );
};
